import React from "react"
import StyledSection from "./hero-section-styles"
import Leaf from "../../images/leaf.png"

const HeroSection = ({ data }) => {
  const { acf } = data
  return (
    <>
      <StyledSection>
        <div className="hero-text">
          <div className="one-line">
            <hr className="h-line" />
            <img src={Leaf} alt="leaf" className="leaf" />
            <hr className="h-line" />
          </div>
          <h6>{acf.sub_heading}</h6>
          <h1>{acf.main_heading}</h1>
        </div>
      </StyledSection>
    </>
  )
}

export default HeroSection
